const STRING = {
    configuracoes: 'Configurações',
    enderecos: 'Endereços',
    odhen_interface: 'Odhen Interface',
    perifericos_DNS: 'Periféricos DNS',
    porta_balanca: 'Porta Balança',
    cores: 'Cores',
    primary_color: 'Cor primária',
    primary_light: 'Cor primária suave',
    primary_dark: 'Cor primária escura',
    header_color: 'Cor do cabeçalho',
    categorie_color: 'Cor das categorias',
    categorie_font_color: 'Cor da fonte das categorias',
    cart_color: 'Cor de fundo do carrinho',
    cart_font_color: 'Cor da fonte do carrinho',
    consumidor: 'Consumidor',
    tipo_consumidor: 'Tipo consumidor',
    codigo_loja: 'Código da loja',
    codigo_filial: 'Código da filial',
    dispositivo: 'Dispositivo',
    digitos_NSU: 'Quantidade de Digitos para NSU (Ex. 13 ou 20) vazio para automático',
    fechamento_automatico: 'Fechamento automático às 00:00?',
    emitir_fechamento_dia: 'Emitir fechamento do dia',
    modalidade_entrega: 'Modalidade de entrega',
    drive_throught: 'Drive Throught',
    comer_aqui: 'Comer Aqui',
    levar: 'Levar',
    parametrizacao_impressora: 'Parametrização de impressora',
    modelo: 'Modelo',
    porta_impressora: 'Porta da impressora',
    testar_impressora: 'Testar Impressora',
    bematech_Mp_20: 'Bematech Mp-20',
    epson_tm_T88IIP: 'Epson Tm-T88IIP',
    bematech_Mp_2100: 'Bematech Mp-2100',
    bematech_Mp_4000: 'Bematech Mp-4000',
    sewoo_chile: 'Sewoo - Chile',
    IBM_4610_colombia: 'IBM-4610 - Colômbia',
    bematech_MP_100_peru: 'Bematech MP-100 - Peru',
    daruma_DR600: 'Daruma DR600',
    epson_TM_U22A: 'Epson TM-U22A',
    daruma_DR700: 'Daruma DR700',
    epson_M244A: 'Epson M244A',
    zebra_Tlp_2844: 'Zebra Tlp 2844',
    bematech_MP_4200: 'Bematech MP-4200',
    epson_TM_T88V: 'Epson TM-T88V',
    epson_TM_T20: 'Epson TM-T20',
    sweda_SI_300S: 'Sweda SI-300S',
    elgin_I9: 'Elgin I9',
    epson_TM_T88IV_ethernet: 'Epson TM-T88IV Ethernet',
    elgin_kiosk_BKT681: 'Elgin Kiosk BKT681',
    bematech_MP_4200_compartilhada: 'Bematech MP-4200 - Compartilhada',
    custom_TG2480H: 'Custom TG2480H',
    gpos700: 'GPOS700',
    poynt: 'Poynt',
    tectoy_impressora_pequena: 'K2 Mini - Imp P',
    tectoy_impressora_grande: 'K2 Mini - Imp G',
    gerais: 'Gerais',
    modo_TAP: 'Modo TAP?',
    modo_balanca: 'Modo balança Toledo Prix 3?',
    habilita_agruparnaimpressao: 'Habilita agrupar na impressao',
    habilita_modo_slim: 'Habilita modo slim',
    habilita_leitura_cod: 'Habilita leitura de código de barras dos produtos',
    habilita_acessibilidade: 'Habilita modo acessibilidade',
    habilita_modo_edicao: 'Habilita modo edição de cores',
    exibir_produtos_sem_foto: 'Exibir produtos sem foto?',
    exibir_a_partir_de: 'Exibir "a partir de" proximo aos preços?',
    exibe_botao_continuar_comprando: 'Exibe botão "Continuar Comprando" no carrinho?',
    cardapio_deve_expirar: 'Cardápio deve expirar em 30 minutos?',
    utiliza_pager: 'Utiliza Pager?',
    altera_quantidade_adicionais: 'Permite alterar quantidade dos adicionais?',
    imprime_espelho_pedido: 'Imprime Pedido?',
    habilita_subgrupos: 'Habilita Subgrupos?',
    habilita_observacao_digitada: 'Habilita Observação Digitada?',
    exibe_itens_em_lista: 'Exibe itens do grupo promocional em lista?',
    minimiza_grupo_quantidade_maxima: 'Minimiza grupo ao atingir a quantidade máxima?',
    taxa_servico_fixa: 'Utiliza Taxa de Serviço Fixa?',
    diferenca_preco_minimo: 'Exibe diferença do preço mínimo?',
    pagamentos_homologacao: 'Pagamentos de Homologação? (Não Ativar em produção)',
    imagens_customizaveis: 'Imagens Customizáveis (jpg, png)',
    configurar: 'Configurar',
    usuario: 'Usuário',
    senha: 'Senha',
    entrar: 'Entrar',
    cancelar: 'Cancelar',
    version: 'Versão',
    confirmar: 'Confirmar',
    itens_pesaveis: 'Itens pesáveis',
    cancelamento_TEF: 'Cancelamento de TEF',
    NSU: 'NSU',
    nota_fiscal: 'Nota Fiscal',
    data: 'Data',
    valor: 'Valor',
    debito: 'Débito',
    credito: 'Crédito',
    pix_carteira_digital: 'PIX / Carteira Digital',
    voltar: 'Voltar',
    cancelar_TEF: 'Cancelar TEF',
    siga_instrucoes_pinpad: 'Siga as instruções no Pinpad',
    carrinho_vazio: 'Seu carrinho está vazio',
    total_caps: 'TOTAL',
    confirmar_pedido: 'Confirmar Pedido',
    reverter: 'Reverter',
    aplicar: 'Aplicar',
    esta_por_ai: 'Olá! Está por aí?',
    seu_pedido_te_espera: 'Seu pedido te espera',
    toque_para_voltar_ao_pedido: 'Toque para voltar ao seu pedido!',
    para_expirar: 'para expirar',
    pedido_para: 'Seu pedido é para:',
    viagem: 'Viagem',
    cadastrar_nova_senha: 'Cadastrar Nova Senha',
    repita_a_senha: 'Repita a Senha',
    aguarde: 'Aguarde',
    fechar: 'Fechar',
    alguma_observacao: 'Alguma Observação?',
    observacao_livre: 'Observação Livre',
    sem_observacao: 'Sem Observação',
    login_consumidor: 'Login Consumidor',
    login_sucesso: 'Login realizado com sucesso!',
    total_da_compra: 'Total da Compra:',
    saldo_familia: 'Saldo Família',
    total_familia: 'Total Família',
    saldo_apos_pagamento: 'Saldo após pagamento',
    saldo_cliente: 'Saldo do Cliente:',
    recarregar_saldo: 'Recarregar Saldo',
    confirmar_pagamento: 'Confirmar Pagamento',
    imprime_cupom_fiscal: 'Imprime Cupom Fiscal?',
    sim: 'Sim',
    nao: 'Não',
    enviar_por_e_mail: 'Enviar por E-mail',
    e_mail: 'E-mail',
    bloquear_desbloquear_produtos: 'Bloquear / Desbloquear produtos',
    validacao_fiscal_produtos: 'Bloquear Produtos com Pendências',
    com_pendencia_fiscal: 'Pendência fiscal',
    sem_imposto: 'Sem imposto',
    a_partir_de: 'A partir de:',
    a_partir_de_gom: 'A partir de ',
    recarga_de_saldo: 'Recarga de Saldo',
    valor_da_recarga: 'Valor da Recarga',
    CPF: 'CPF',
    familia_de_produtos: 'Família de Produtos',
    selecione_forma_pagamento: 'Selecione a forma de pagamento:',
    personalize_seu_combo: 'Personalize seu combo:',
    carrinho: 'Carrinho',
    comanda: 'Comanda:',
    remover: 'Remover',
    adicionar_nova_pesagem: 'Adicionar nova pesagem',
    adicionar_mais_comandas: 'Adicionar mais comandas',
    total_dois_pontos: 'TOTAL:',
    continuar_comprando: 'Continuar Comprando',
    realizar_pagamento: 'Realizar Pagamento',
    digite_numero_comanda_ou_faca_leitura: 'Digite o número de sua comanda ou faça a leitura do código de barras',
    digite_valor_deseja_pagar: 'Digite o valor que deseja pagar',
    modo_acessibilidade: 'Modo Acessibilidade',
    digite_numero_comanda: 'Digite o número de sua comanda',
    identificacao_de: 'Identificação de ',
    comanda_minusculo: 'comanda',
    comanda_maiusculo: 'Comanda',
    digitar_com_teclado: 'Digitar com teclado',
    descricao: 'Descrição: ',
    confirmar_edicao: 'Confirmar Edição',
    adicionar_ao_carrinho: 'Adicionar ao Carrinho',
    pagamento: 'Pagamento',
    informar_CPF_na_nota: 'Deseja informar CPF/CNPJ na nota fiscal?',
    CNPJ: 'CNPJ',
    nao_informar: 'Não Informar',
    CPF_CPNJ: 'CPF / CNPJ',
    todos_campos_obrigatorios: 'Todos os campos são obrigatórios',
    data_informada_formato: 'A data deve ser informada no formato DDMMAAAA',
    valor_informado_casas_decimais: 'O valor deve ser informado com no máximo duas casas decimais',
    selecione_tipo_cancelamento: 'Selecione um tipo de reimpressão ou cancelamento',
    atingiu_limite_categoria: 'Você atingiu o limite de itens dessa categoria.',
    escolha: 'Escolha ',
    ate: 'até',
    opcao: ' opção',
    opcoes: ' opções',
    senhas_nao_sao_iguais: 'As senhas inseridas não são iguais',
    senha_cadastrada_sucesso: 'Senha Cadastrada com Sucesso!',
    nao_possivel_criar_nova_senha: 'Não foi possível criar uma nova senha para este usuário',
    houve_erro_ao_realizar_login: 'Houve um erro ao tentar realizar o login',
    erro_editar_consumidor_do_pedido: 'Erro ao editar o consumidor do pedido',
    preencha_e_mail_corretamente: 'Preencha o campo e-mail corretamente ou selecione outra opção de impressão',
    e_mail_digitado_nao_e_valido: 'O e-mail digitado não é válido',
    valor_informado_deve_ser_maior_que_zero: 'O valor informado deve ser maior que zero',
    selecione_familia_produtos: 'Selecione uma família de produtos',
    recarga_realizada_com_sucesso: 'Sua recarga foi realizada com sucesso!',
    operacao_negada_autorizador_tente_novamente: 'Operação negada pelo autorizador. <br><br> Verifique se a senha foi digitada corretamente, se o cartão possui saldo/limite e tente novamente',
    operacao_cancelada_operador_tente_novamente: 'Operação cancelada pelo operador. <br><br> Selecione a forma de pagamento e tente novamente',
    nao_possivel_realizar_recarga_valor_estornado: 'Não foi possível realizar sua recarga. <br><br> O valor pago já foi estornado.',
    qual_sabor_deseja: 'Qual sabor deseja?',
    posso_fazer_sugestao_tamanho: 'Posso fazer uma sugestão de tamanho?',
    posso_fazer_sugestao_combo: 'Posso fazer uma sugestão de combo?',
    leia_o_QR_code: 'Leia o QR Code',
    nao_ha_produto_padrao_pesagem_parametrizado: 'Não há um produto padrão para a pesagem parametrizado.',
    taxa_de_servico: 'Taxa de serviço: ',
    nome_dispositivo_obrigatorio: 'O nome do dispositivo é obrigatório!',
    endereco_interface_obrigatorio: 'O endereço da Odhen Interface é obrigatório!',
    endereco_perifericos_obrigatorio: 'O endereço do periféricos é obrigatório!',
    preenchimento_das_cores_obrigatorio: 'O preenchimento das cores é obrigatório!',
    cores_nao_podem_ser_iguais: 'As cores não podem ser iguais',
    parametros_aba_consumidor_faltando: 'Existem parametros da aba do consumidor que estão faltando',
    precisa_associar_totem_a_um_caixa: 'Você precisa associar o totem a um caixa',
    versao_interface: 'Versão da Odhen Interface ',
    incompativel_com_o_TAA_necessario_versao: ' incompatível com o TAA. Necessário versão ',
    ou_superior: ' ou superior',
    tamanho_imagem_menor_que_5MB: 'Tamanho da imagem deve ser menor do que 5MB',
    interface_nao_encontrada_404: '404 - Odhen Interface não encontrada, confira os arquivos de configuração no servidor.',
    sucesso_interface: 'Sucesso Odhen Interface </br>',
    senha_invalida: 'Senha inválida',
    realizar_login_outro_usuario: 'Realizar login como outro usuário?',
    deseja_realizar_logoff_usuario: `Tem certeza de que deseja realizar logoff do usuário?`,
    logado_como: 'Logado como',
    usuario_logado: 'Usuário Logado',
    escolha_forma_pagamento: 'Escolha uma forma de pagamento',
    escolha_forma_pagamento_complementar: 'Escolha a forma de pagamento complementar:',
    realize_pagamento_principal: 'Realize o pagamento principal escolhido:',
    adicionar_taxa_servico: 'Gostaria de adicionar a taxa de serviço no valor de ',
    CPF_CNPJ_invalido: 'CPF/CNPJ inválido.',
    deseja_complementar: '<br><br>Deseja complementar ',
    com_outra_forma_pagamento: ' com outra forma de pagamento?',
    voce_precisa_selecionar_algum: 'Você precisa selecionar algum ',
    terminal_de_auto_atendimento: 'TAA - Terminal de Auto Atendimento',
    deseja_limpar_carrinho: 'Tem certeza que deseja limpar o carrinho?',
    deseja_cancelar_pagamento: 'Deseja cancelar o pagamento desta comanda?<br><br>Esta comanda possui itens lançados. Caso deseje remover os itens, procure um caixa para realizar a operação.',
    certeza_que_deseja_remover: 'Tem certeza que deseja remover ',
    do_carrinho: ' do carrinho?',
    cliente_login_nao_e_o_mesmo_comanda: 'O cliente que realizou login não é o mesmo identificado na comanda---',
    foi_excedido_aspas: '" foi excedido',
    seu_saldo_familia_de_produtos: 'Seu saldo para a família de produtos "',
    e_insuficiente: '" é insuficiente',
    foi_excedido: ' foi excedido',
    saldo_insuficiente_completar_venda: 'Seu saldo é insuficiente para completar esta venda com a taxa de serviço',
    seu_saldo_esta_abaixo_de: 'Seu saldo está abaixo de ',
    seu_saldo: 'Seu saldo ',
    da_familia_de_produtos: 'da família de produtos ',
    das_familias_de_produtos: 'das famílias de produtos ',
    e: ' e ',
    esta_abaixo_de: ' está abaixo de ',
    nao_foi_possivel_configurar_pinpad: 'Não foi possível configurar o PinPad para iniciar a transação. Verifique se o periféricos está rodando',
    operacao_negada_pelo_autorizador: 'Operação negada pelo autorizador',
    problema_execucao_rotinas_pinpad: 'Problema na execução de alguma das rotinas no pinpad',
    cancelamento_TEF_finalizado_sucesso: 'Cancelamento de TEF finalizado com sucesso',
    configuracoes_faltantes_404: '404 - Existem configurações faltantes!',
    nao_foi_possivel_receber_XML: 'Não foi possível receber o XML da nota fiscal através da Odhen Interface',
    nao_foi_possivel_completar_venda: 'Não foi possível completar a venda. O valor pago foi estornado.',
    nao_possivel_completar_venda: 'Não foi possível completar a venda.',
    imagem_tela_de_espera: 'Imagem tela de espera',
    logo: 'Logo',
    produtos_sem_foto: 'Produtos sem foto',
    instrucoes_pager: 'Instruções pager',
    instrucoes_balanca: 'Instruções Balança',
    instrucoes_TAP: 'Instruções TAP',
    instrucoes_da_maquininha: 'Instruções da maquininha',
    instrucoes_da_impressora: 'Instruções da impressora',
    erro_de_impressora: 'Erro de impressora',
    erro_ao_salvar_venda: 'Erro ao salvar venda',
    erro_de_pinpad: 'Erro de Pinpad',
    erro_pinpad_2: 'Erro Pinpad 2',
    idiomas: 'Idiomas',
    idiomas_adicionais: 'Idiomas Adicionais',
    idioma_principal: 'Idioma Principal',
    portugues: 'Português',
    ingles: 'Inglês',
    espanhol: 'Espanhol',
    cupom_fiscal: 'Cupom Fiscal?',
    imprimir: 'Imprimir',
    nao_preciso_do_cupom: 'Não preciso do cupom',
    importar_exportar_configuracoes: 'Importar / Exportar Configurações',
    definir_configuracoes_como_padrao: 'Definir estas configurações como padrão',
    importar_configuracoes_servidor: 'Importar configurações do servidor',
    remover_opcoes_impressao_envio_cupom_fiscal: 'Remover opções de impressão e envio do cupom fiscal?',
    problema_nao_identificado_TEF: 'Ocorreu um problema não identificado com o TEF',
    pagamento_nao_disponivel_para_este_usuario: 'Esta forma de pagamento não está disponível para este usuário. <br><br> Selecione outra forma de pagamento.',
    nao_foi_possivel_configurar_pinpad_tente_novamente: 'Não foi possível configurar o PinPad para iniciar a transação. Verifique se o periféricos está rodando <br><br> Qualquer valor pago será estornado <br><br> Tente novamente',
    problema_execucao_rotinas_pinpad_tente_novamente: 'Problema na execução de alguma das rotinas no pinpad <br><br> Qualquer valor pago será estornado <br><br> Tente novamente',
    problema_nao_identificado_TEF_tente_novamente: 'Ocorreu um problema não identificado com o TEF <br><br> Qualquer valor pago será estornado <br><br> Tente novamente',
    utiliza_layout_alternativo: 'Utiliza layout alternativo?',
    proximo: 'Próximo',
    endereco_sitef: 'Endereço Sitef',
    video_nao_permitido: 'Arquivo de vídeo só é permitido na "Imagem da tela de espera"',
    configuracoes_salvas_para_caixa: 'Existem configurações salvas para o caixa',
    importar_configuracoes: '<br> Deseja importar as configurações?',
    deseja_importar_configuracoes_servidor: 'Deseja importar as configurações padrão do servidor?',
    deseja_definir_configurações_atuais_padrão: 'Deseja definir as configurações atuais deste TAA como padrão?',
    configuracoes_importadas_sucesso: 'As configurações do caixa foram importadas com sucesso!',
    falha_importar_config_caixa: 'Não foi possivel importar as configurações do caixa.',
    configuracao_definida_padrao: 'As configurações deste TAA foram definidas como padrão!',
    configuracao_padrao_importada: 'As configurações padrão foram importadas com sucesso!',
    falha_importar_config_padrao: 'Não foi possivel carregar as configurações do servidor.',
    utiliza_leitor_barras: 'Leitor de Código de Barras?',
    insira_numero_comanda: 'Insira o número da sua comanda:',
    insira_numero_pager: 'Insira o número do pager',
    por_favor_insira_comanda: 'Por favor, insira o número da sua comanda',
    escolha_um_grupo: 'O que você deseja?',
    concluir: 'Concluir',
    limpar: 'Limpar',
    pesquisar: 'Pesquisar: ',
    nao_ha_itens: 'Não há itens cacheados no TAA. <br> Para utilizar a função "Bloquear/Desbloquear" é necessário ter acessado o menu de produtos. Após carregar os produtos esta função estará disponível.',
    ultimo_fechamento_dia_sucesso: 'O último fechamento do dia foi realizado com sucesso. <br><br> Este caixa encontra-se bloqueado até o próximo dia.',
    fechamento_caixa_sucesso: 'O fechamento de caixa foi realizado com sucesso.',
    este_e_ultimo_fechamento_dia: 'Este é o último fechamento do dia?',
    caixa_bloqueado: 'Último fechamento do dia já foi realizado para este totem. <br><br> O caixa está bloqueado.',
    nao_possui_acesso_suficiente: 'Você não possui acesso suficiente para concluir esta operação',
    permissoes_nao_cadastradas: 'As permissões para este usuário não foram cadastradas. <br><br> Acesse a tela "Controle de Acesso TAA mobile" no Retail e realize o cadastro. <br><br> O TAA lê exclusivamente as permissões cadastradas naquela tela.',
    price_font_color: 'Cor da fonte do preço',
    preco_em_negrito: 'Habilita fonte do preço em negrito',
    reimpressao_cupom_fiscal: 'Reimpressão/Cancelamento de Cupom Fiscal',
    visualizar: 'Visualizar',
    data_dois_pontos: 'Data: ',
    verificar_conexao: 'Verificar Conexão',
    verificar_pendencias: 'Verificar Pendências de Imposto',
    existem_produtos_com_inconsistencia_fiscal: 'Existem produtos com inconsistência fiscal. <br>Por favor, regularize a situação ou bloqueie os produtos com pendências.',
    pendente: 'Pendente',
    processando: 'Processando...',
    falha: 'Falha',
    concluido: 'Concluído',
    atualizar_informações_caixa: 'Atualizar Informações do Caixa',
    atualizar_recebimentos: 'Atualizar Tipos de Recebimentos',
    atualizar_imagens: 'Atualizar Imagens',
    atualizar_cardapio: 'Atualizar Cardápio',
    aplicar_configuracoes: 'Aplicar Configurações',
    identificacao: 'Identificação',
    informe_celular: 'Por favor, insira seu número de celular:',
    nao_q_informar: 'Não quero informar',
    prox: 'Prox',
    utiliza_layout_gom: 'Utiliza Layout Gom',
    informe_cpf: 'Informe o CPF',
    informe_cpf_cnpj: 'Informe o CPF ou CNPJ',
    cancelar_pedido: 'Cancelar Pedido',
    voltar_cardapio: 'Voltar ao Cardápio',
    boas_noticias: 'Boas notícias!',
    voce_possui: 'Você possui ',
    utiliza_desconto: ' de desconto para utilizar. Deseja utilizar nesta compra?',
    desconto_aplicado: 'Desconto aplicado com sucesso!',
    valor_compra: 'Valor da compra: ',
    desconto: 'Desconto: ',
    total_dois_pontos_simples: 'Total: ',
    agora_nao: 'Agora não',
    aplicar_desconto: 'Aplicar desconto',
    continuar: 'Continuar',
    erro_valor_compra: 'Valor informado superior ao valor total da compra!',
    erro_valor_desconto: 'Valor informado superior ao valor disponível para desconto!',
    compra_concluida: 'Compra concluída.',
    aguarde_impressao: 'Aguarde a impressão do pedido!',
    pedido_impresso: 'Pedido impresso com sucesso!',
    falha_enviar_pedido: 'Falha ao enviar pedido.',
    pedido: 'Pedido ',
    enviado_aguarde: 'enviado. Aguarde...',
    aguardando_cupom: 'Aguardando cupom fiscal.',
    falha_cupom: 'Falha ao receber o cupom fiscal.',
    cupom_recebido: 'Cupom fiscal recebido com sucesso.',
    solicita_cancelamento: 'Solicitando o cancelamento da venda numero',
    venda: 'A venda',
    sera_cancelada: 'será cancelada!',
    finalizando_compra: 'Finalizando sua compra. Aguarde...',
    imprimindo_cupom: 'Imprimindo cupom fiscal. Aguarde...',
    cupom_impresso: 'Cupom fiscal impresso!',
    timeOut_inatividade: 'Timeout de inatividade (segundos)',
    timeOutInModal_inatividade: 'Timeout durante o modal de inatividade (segundos)',
    keyboard_clear: 'Limpar',
    keyboard_accept: 'Confirmar',
    posicione_o_codigo: 'Posicione o código',
    de_barras_comanda: 'de barras da comanda',
    no_leitor_abaixo: 'no leitor abaixo',
    ou_digite_numero_comanda: 'ou digite o número da comanda:',
    keyboard_space: 'Espaço',
    confira_seu_pedido: 'Confira seu pedido',
    interface_sem_conexao: 'Odhen interface sem conexão com o banco de dados.',
    voltar_tela_inicial: 'Voltando a tela inicial ',
    msg_pager: 'Você pode acompanhar seu pedido através do celular, apontando a câmera para o QRCODE ao lado.',
    msg_qrcode: 'Este QRCODE também é impresso ao final do seu cupom fiscal',
    voltar_agora: 'Voltar agora',
    menor_zero: 'O valor informado deve ser maior que 0',
    avanca_grupo_quantidade_maxima: 'Avança grupo automaticamente ao atingir a quantidade máxima?',
    interface_address: 'Endereço da interface',
    imprimir_pedidos_em_fichas: 'Imprimir pedidos em fichas',
    demora_aguarde: `Isso está demorando mais que o esperado. \n Por favor aguarde...`,
    taxa_servico_automatica: 'Aplica taxa de serviço automaticamente',
    remove_taxa_servico: 'Permite remover a taxa de serviço no TAP',
    va_ao_caixa: 'Dirija-se ao caixa para solicitar a retirada da taxa de serviço.',
    apresente_cod_barras: 'Apresente o código de barras do produto no leitor:',
    apresente_novamente: 'Apresente o código de barras no leitor para adicionar mais produtos',
    produto_nao_encontrado: 'Não foi encontrado produto para o código de barras informado!',
    bar_code_cracha: 'Apresente o código do crachá no leitor de código de barras.',
    adicionar_produto: 'Adicionar Produto',
    alteracoes_desfeitas: 'Todas as alterações realizadas no carrinho nesta tela serão desfeitas. Deseja continuar?',
    produtos_excedidos: 'Alguns produtos excederam a quantidade maxima permitida.',
    alterar_produtos: 'Você pode alterar os produtos aqui ou voltar para cardápio.',
    de: 'de',
    voltar_inicio: 'Voltar para tela inicial',
    redirecione_caixa: 'Dirija-se ao caixa para realizar o pagamento.',
    alterar_metodo_cracha: 'Entrar com crachá',
    alterar_metodo_rec: 'Entrar com reconhecimento facial',
    alterar_metodo_senha: 'Entrar com login e senha',
    saldo_inferior: 'Seu saldo não pode ficar inferior á ',
    valor_max_mensal_forma_pagamento: 'Seu consumo mensal não pode ser superior à ',
    valor_max_diario_forma_pagamento: 'Seu consumo diário não pode ser superior à ',
    valor_max_mensal_familia: 'O valor máximo mensal da família de produtos "',
    valor_max_diario_familia: 'O limite diário da família de produtos "',
    erro_comanda_vazia: 'Houve uma falha na leitura da comanda. Por favor tente novamente ou vá ao caixa para realizar o pagamento.',
    carrinho_valor_0: 'Não é possivel realizar o pagamento de comanda com valor RS 0,00, por favor dirija-se ao caixa.',
    comanda_nao_encontrada: 'Comanda não possui consumo.',
    reenviar: 'Reenviar',
    informe_pin: 'Digite o código PIN que enviamos para seu celular.',
    fidelidade_message: 'Insira seu número de celular e acumule pontos no nosso programa de fidelidade.',
    falha_cupom_fiscal: `Falha na impressora. \n \n Não foi possível reimprimir o cupom fiscal.`,
    falha_cupom_interface: 'Não foi possível receber o cupom fiscal através da Odhen interface',
    cancelamento_manual: 'Não foi possivel obter os dados para cancelamento. Faça o cancelamento manual através da tela de cancelamento de TEF',
    cancelamento_manual_mult_pag: 'Este cupom possui mais de 1 pagamento pelo tef. Faça o cancelamento manual através da tela de cancelamento de TEF',
    confirma_cancelamento: 'Confirma o cancelamento da venda?',
    cancelamneto_realizado: 'Cancelamento realizado com sucesso',
    cancelar_venda: 'Cancelar venda',
    verificar_params: 'Verificar Parâmetros',
    pedido_concluido_erro_impressora_1: 'Seu pedido foi concluído!',
    pedido_concluido_erro_impressora_2: 'No entanto, houve um pequeno problema com a impressora.',
    pedido_concluido_erro_impressora_3: 'Para receber o comprovante de compra:',
    pedido_concluido_erro_impressora_4: '* Tire uma foto das informações que aparecem abaixo.',
    pedido_concluido_erro_impressora_5: '* Leve essa foto ao caixa e peça para imprimir seu comprovante.',
    pedido_concluido_erro_impressora_6: 'Senha do PEDIDO: ',
    pedido_concluido_erro_impressora_7: 'Número da venda: ',
    pedido_concluido_erro_impressora_8: 'Clique em qualquer lugar da tela para retornar à página inicial.',
    pedido_concluido_erro_impressora_9: 'Obrigado pela compreensão!',
    pedido_concluido_erro_impressora_10: 'Número do cupom fiscal: ',
    data_pedido: 'Data: ',
    clique_executar_para_iniciar: 'Clique em "Executar" para iniciar as funções administrativas',
    confirma_reimpressao_tef: 'Deseja reimprimir o cupom fiscal e o comprovante TEF?',
    reimprimir_TEF: 'Reimprimir TEF',
    nao_ha_dados_tef: 'Não há dados do TEF',
    confirma_cancelamento_tef: 'Confirma cancelamento?',
    dados_invalidos: 'Dados inválidos',
    funcoes_sitef: 'Funções Sitef',
    alterar_cpf_cnpj: 'Alterar CPF/CNPJ',
    informa_cpf: 'Informar CPF/CNPJ',
    veja_mais: '... Veja mais',
    editar: 'Editar',
    escolha_pelo_menos: 'Escolha no mínimo',
    observacao: 'observação',
    observacoes: 'observações',
    desconto_cashback: 'Desconto',
    faca_leitura_do_codigo_de_barras: 'Por favor, aproxime o código de barras do leitor',
    de_cashback_para_a_proxima_compra: 'de cashback para a próxima compra',
    aplicado_no_total_do_pedido: 'aplicado no total do pedido',
    aplicado_nos_produtos_selecionados: 'aplicado nos produtos selecionados',
    frete_gratis: 'frete grátis',
    informe_codigo_cupom: 'Informe o código do cupom',
    codigo_cupom_invalido: 'Código do cupom inválido',
    selecione_o_cupom: 'Selecione o cupom',
    ver_regras: 'Ver regras',
    selecionar: 'Selecionar',
    quero_ganhar_cashback: 'QUERO GANHAR CASHBACK',
    utilizar_cupom: 'UTILIZAR CUPOM',
    tem_um_cupom_utilize_para_garantir_seu_desconto: 'Tem um cupom? Utilize para garantir seu desconto!',
    ao_comprar_acima_de: 'Ao comprar acima de',
    voce_garante: 'você garante',
    de_cashback_na_proxima_compra: 'de cashback para utilizar na próxima compra!',
    voce_informou_seu_telefone_e_ganhara: 'Você informou seu telefone e ganhará',
    na_proxima_compra: 'na próxima compra!',
    rapido_facil_e_com_economia_garantida: 'Rápido, fácil e com economia garantida.',
    pratico_imediato_e_perfeito_para_economizar_mais: 'Prático, imediato e perfeito para economizar mais.',
    informe_seu_telefone_e_ganhe: 'Informe seu telefone e ganhe',
    desconto_nao_pode_exceder_o_valor_do_pedido: 'O desconto não pode exceder o valor do pedido e foi ajustado automaticamente.',
    valido_ate: 'Válido até',
    cupom_de_desconto: 'Cupom de desconto',
    desconto_de: 'Desconto de',
    desconto_de_porcentagem: 'Desconto de',
    cashback_de: 'Cashback de',
    cashback_de_porcentagem: 'Cashback de',
    cep: 'CEP',
    rua: 'Rua',
    numero: 'Número',
    complemento: 'Complemento',
    bairro: 'Bairro',
    cidade: 'Cidade',
    UF: 'UF',
    confirmar_endereco: 'Confirmar Endereço',
    informe_cep: 'Informe seu CEP',
    campos_obrigatorios: 'Por favor, preencha todos os campos obrigatórios.',
    cep_invalido: 'CEP inválido. Por favor, verifique o CEP informado.',
    buscando_endereco: 'Buscando endereço...',
    endereco_nao_encontrado: 'Endereço não encontrado para o CEP informado. Por favor, verifique o CEP ou preencha os dados manualmente.',
    razao_social: 'Razão Social',
    nome_fantasia: 'Nome Fantasia',
    registro_estado: 'Registro Estadual',
    numero_obrigatorio: 'O campo número é obrigatório.',
    registro_estado_obrigatorio: 'O campo registro estadual é obrigatório.',
    nome_fantasia_obrigatorio: 'O campo nome fantasia é obrigatório.',
    ultima_transacao_nao_finalizada: 'A ultima transação não foi finalizada corretamente e será cancelada automaticamente. <br><br> Qualquer valor pago será estornado. <br><br> Por favor, refaça a transação.',
    nenhum_produto_encontrado: 'Nenhum produto encontrado',
    fidelity_lpgd: 'Ao informar o telefone, declaro que estou consentindo com o uso deste dado para fins de cashback, em conformidade com a LGPD.',
    total_do_pedido: 'Total do pedido:',
    valor_do_desconto: 'Valor do desconto:',
    valor_do_cashback: 'Valor do cashback:',
    total_a_pagar: 'Total a pagar:',
    cashback: 'Cashback:',
    adicionou_um_cupom_de_cashback: 'Você adicionou um cupom e ganhará ',
    informe_o_codigo_do_cupom: 'Informe o código do cupom',
    informe_seu_telefone: 'Informe seu telefone',
    utiliza_reconhecimento_facial: 'Utiliza Reconhecimento Facial',
    continuar_como: 'Continuar como',
    nao_e_voce: 'Não é você? Escolha uma das opções abaixo:',
    tentar_novamente: 'Tentar novamente',
    tentar_outro_metodo: 'Tentar outro método',
    aguardando_reconhecimento: 'Posicione seu rosto na câmera...',
    rosto_nao_detectado: 'Rosto não detectado. Garanta boa iluminação e posicionamento correto.',
    rosto_nao_reconhecido: 'Rosto não reconhecido. Tente novamente.',
    reconhecimento_facial_pausado: 'Reconhecimento pausado após múltiplas tentativas.',
    falha_reconhecimento_facial: 'Reconhecimento facial falhou.',
    aguarde_enquanto_realizamos_o_login: 'Aguarde enquanto realizamos o login...',
    login_realizado_com_sucesso: 'Login realizado com sucesso!',
    aguardando_confirmacao_catraca: 'A catraca só será liberada após a confirmação da venda.',
    recarregar_saldo_indisponivel: 'Recarregar saldo indisponível',
    como_deseja_ser_chamado: 'Como deseja ser chamado?',
    digite_seu_nome: 'Digite seu nome',
    complemento_nao_permitido: 'O valor disponivel é insuficiente. Não é possível realizar o pagamento com complemento. Por favor, dirija-se ao caixa para realizar o pagamento ou selecione outra forma de pagamento.',
    cashback_cpf_cnpj: 'Para ganhar cashback é necessário informar o CPF ou CNPJ na nota fiscal.',
    limpar_dados_cashback: 'Limpar dados de cashback',
    verificando_transacoes_pendentes: 'Verificando transações pendentes...',
    finalizando_transacao_pendente: 'Finalizando transação pendente...',
    transacao_pendente_nao_encontrada: 'Nenhuma transação pendente encontrada.',
    erro_ao_verificar_transacoes_pendentes: 'Não foi possivel verificar as transações pendentes.',
    cracha: 'Código do crachá',
    aguardando_impressao_do_cupom: 'Imprimindo cupom fiscal. <br> <br> Por favor, aguarde...',
    nao_puxe_o_papel_da_impressora: 'Não puxe o papel da impressora, até que a impressão seja concluída.',
    cancelando_comanda_pendente: 'Cancelando comanda pendente...',
    concluindo_comanda_pendente: 'Concluindo comanda pendente...',
    cancelando_venda_pendente: 'Cancelando venda pendente...',
    concluindo_venda_pendente: 'Concluindo venda pendente...',
    ultima_transacao_nao_finalizada_cancelada: 'A última transação não finalizada foi cancelada. <br><br> Qualquer valor pago será estornado. <br><br> Por favor, refaça a transação ou dirija-se ao caixa para realizar o pagamento.',
    ultima_transacao_nao_finalizada_concluida: 'A última transação não finalizada foi concluída. Caso necessário solicite ao caixa a reimpressão do cupom fiscal.',
    nao_foi_possivel_confirmar_transacao: 'Não foi possível confirmar a transação.',
    nao_ha_venda_a_ser_finalizada: 'A última transação não finalizada corretamente. Qualquer valor pago será estornado. Por favor, refaça a transação ou dirija-se ao caixa para realizar o pagamento.',
    reconhecimento_facial: 'Reconhecimento Facial',
    senha_de_acesso: 'Senha de Acesso',
    nao_quero_identificar: 'Continuar sem identificar',
    nao_foi_possivel_realizar_login: 'Não foi possível realizar o login.',
    qr_code_catraca: 'QR Code para liberação da catraca',
    ignore_qrCode: 'Ignorar leitura do QR Code no SK210',
    ocultar_detalhes: 'Ocultar detalhes',
    ver_detalhes: 'Ver detalhes',
    desconto_dois_pontos: 'Desconto: ',
    subtotal_dois_pontos: 'Subtotal: ',
    cancelar_selecao: 'Deseja cancelar o lançamento?',
    produto_obrigatorio: 'Produto obrigatório',
    remove_produto_sugestao_automatico: 'Remover produto redundante da sugestão?',
    utiliza_login_inicio: 'Utiliza login no inicio da aplicação?',
    sinaliza_desconto: 'Sinaliza com um taxado o preço antigo ao lado do novo preço com desconto.',
    nao_obrigado: 'Não obrigado',
    finalizar: 'Finalizar',
    avancar: 'Avançar',
    combina_com_seu_pedido: 'Combina com seu pedido',
    ver_opcoes: 'Ver opções',
    adicionar: 'Adicionar',
    powered_by: 'INOVAÇÃO E TECNOLOGIA PARA FOODSERVICE',
    valor_complemento: 'Valor a complementar: ',
    exibe_saldo_consumidor_sem_controle: 'Exibe saldo do consumidor que não controla saldo',
    comanda_nao_encontrada_abrir_nova: 'Esta comanda não possui consumo registrado. Deseja incluir um novo produto? <br> <br> <b>A comanda será aberta automaticamente.</b>',
    ao_adicionar_produtos_nao_sera_possivel_separar_as_comandas: 'Ao adicionar produtos não será possível separar as comandas.<br> <br> <b>Deseja continuar?</b>',
    clarity_project_id: 'ID do projeto do Microsoft Clarity',
    remove_imprimir_cupom: 'Remove a opção de imprimir cupom fiscal',
    sem_imprimir_comprovante_e_pedido: 'Permite a conclusão da venda sem imprimir comprovante e pedido?'
}

const getString = function (key) {
    if (!STRING[key]) {
        return key
    }
    return STRING[key]
}

export default {
    getString: getString
}



// WEBPACK FOOTER //
// ./src/assets/lang/pt-br.js